module.exports = __webpack_public_path__ + "static/media/rkumar.b0d0723a.png";